import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";

interface Props {
    value: string;
    onChange: (index: number, key: string, value: string) => void;
    index: number;
    validationError?: string;
    clearFieldError?: (field: string) => void;
}

export const TitleContentInput: React.FC<Props> = ({ value, onChange, index, validationError, clearFieldError }) => (
    <div className="space-y-2">
        <Label className="text-white text-sm">
            Título
        </Label>
        <Input
            value={value}
            onChange={(e) => {
                onChange(index, 'value', e.target.value);
                clearFieldError?.(`contents.${index}.value`);
            }}
            placeholder="Digite o título"
            className={`bg-white/[0.03] border-white/[0.06] text-white ${
                validationError ? 'border-red-500' : ''
            }`}
        />
        {validationError && (
            <p className="text-red-500 text-sm mt-1">{validationError}</p>
        )}
    </div>
);
